// extracted by mini-css-extract-plugin
export default {"locator":"K5c_KOHmYLHHcAKTlVOG","in":"npRPxP2cpve3FGb7QLkT","pkg":"JXimsv_L2MkD6mYzmCFA"};